<template>
  <div class="taskbook-page">
    <!-- 左侧编辑器 -->
    <div class="editor-panel">
      <div class="panel-header">
        <div class="panel-title">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="panel-icon">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
          <span>文档配置</span>
        </div>
        <button class="btn-history" @click="showHistoryDialog">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          历史数据
        </button>
      </div>

      <div class="ai-form-panel">
        <el-form :model="form" :rules="rules" ref="taskForm" label-position="top">
          <el-form-item label="课题名称" prop="title">
            <el-input v-model="form.title" placeholder="例如：基于SpringBoot的在线购物平台设计与实现" clearable maxlength="100" show-word-limit />
          </el-form-item>

          <el-form-item label="课题简要描述" prop="description">
            <textarea v-model="form.description" class="func-editor"
              placeholder="请详细描述课题信息，例如：
1. 使用的技术栈（如：SpringBoot、Vue、MySQL等）
2. 系统角色说明（如：管理员、普通用户、商家等）
3. 主要功能列表（如：用户管理、商品管理、订单管理等）
4. 系统特点和创新点
描述越详细，AI生成的内容越精确" />
          </el-form-item>

          <el-form-item label="标题配置">
            <div class="column-config">
              <div class="column-header">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="column-icon">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                </svg>
                <span>列标题 ({{ form.columns.length }}/15)</span>
                <button type="button" class="btn-add-column" @click="addColumn" :disabled="form.columns.length >= 15">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="16" height="16">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
                  </svg>
                </button>
              </div>
              <div class="column-list">
                <div v-for="(column, index) in form.columns" :key="index" class="column-item">
                  <div class="column-row">
                    <span class="column-number">{{ index + 1 }}</span>
                    <el-input v-model="column.title" placeholder="输入列标题" size="small" class="column-title-input" />
                    <button type="button" class="btn-remove-column" @click="removeColumn(index)">
                      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="16" height="16">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4"/>
                      </svg>
                    </button>
                  </div>
                  <div class="column-row">
                    <span class="word-limit-label">生成字数限制：</span>
                    <el-input-number v-model="column.wordLimit" :min="100" :max="3000" :step="50" size="small" class="column-limit-input" />
                    <span class="word-limit-unit">字</span>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div class="panel-footer">
        <button class="btn-ai" @click="generate" :disabled="loading">
          <span class="btn-content">
            <img src="@/assets/ai-logo.png" alt="AI" class="ai-icon" />
            {{ loading ? 'AI 生成中...' : 'AI 生成报告' }}
          </span>
          <span class="btn-points">（消耗{{ pointsConfig.taskBook }}积分）</span>
        </button>
      </div>
    </div>

    <!-- 右侧预览区 -->
    <div class="preview-panel">
      <div class="preview-header">
        <div class="preview-title">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="panel-icon">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
          生成结果
        </div>
        <div class="preview-meta" v-if="sections.length > 0">
          <button class="btn-export" @click="exportWord">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="15" height="15">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
            </svg>
            导出 Word
          </button>
        </div>
      </div>

      <div class="preview-content">
        <div v-if="loading && sections.length === 0" class="loading-state">
          <div class="loading-spinner"></div>
          <p>AI 正在生成任务书...</p>
          <p class="loading-sub" v-if="progress">{{ progress }}</p>
          <p class="loading-sub" v-else>预计需要几分钟，请稍候</p>
        </div>
        <div v-else-if="sections.length === 0" class="empty-state">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="48" height="48">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
          <p>填写左侧信息后点击「AI 生成报告」</p>
        </div>
        <div v-else class="document-body">
          <!-- 全局进度提示 -->
          <div v-if="loading && progress" class="global-progress-bar">
            <span class="progress-text">{{ progress }}</span>
            <span class="progress-dots"><span>.</span><span>.</span><span>.</span></span>
          </div>
          
          <!-- 段落展示区域 -->
          <div v-for="(section, index) in sections" :key="index" class="section-row">
            <div class="section-content">
              <!-- 单个章节重新生成进度 -->
              <div v-if="regeneratingIndex === index" class="section-progress">
                <span class="progress-text">正在重新生成...</span>
                <span class="progress-dots"><span>.</span><span>.</span><span>.</span></span>
              </div>
              <div v-html="formatSectionText(section)"></div>
            </div>
            <!-- 所有章节都显示操作框 -->
            <div class="section-control">
              <div class="control-box">
                <div class="control-title">替换内容要求</div>
                <textarea 
                  v-model="section.editContent" 
                  class="control-textarea" 
                  placeholder="输入修改意见或新内容..."
                  :maxlength="section.wordLimit || 1000"
                ></textarea>
                <div class="control-actions">
                  <div class="word-limit-row">
                    <span class="word-limit-label">字数限制：</span>
                    <el-input-number 
                      v-model="section.wordLimit" 
                      :min="100" 
                      :max="3000" 
                      :step="50" 
                      size="small" 
                      class="word-limit-input"
                    />
                  </div>
                  <button 
                    class="btn-regenerate" 
                    @click="regenerateSection(index)"
                    :disabled="regeneratingIndex === index"
                  >
                    {{ regeneratingIndex === index ? '生成中...' : '重新生成' }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 历史数据弹框 -->
    <el-dialog
      title="历史数据"
      :visible.sync="showHistoryModal"
      width="1000px"
      :before-close="closeHistoryDialog"
    >
      <div class="history-content">
        <div class="history-description" style="margin-bottom: 12px;">
          <ul>
            <li>• 共有 {{ savedTaskBooks.length }} 个已保存的任务书（按保存时间倒序排列）</li>
            <li>• 点击"加载"按钮可以加载对应的任务书</li>
            <li>• 系统最多保存20条历史数据记录</li>
          </ul>
        </div>

        <el-table
          :data="paginatedTaskBooks"
          stripe
          style="width: 100%"
          empty-text="暂无保存的历史数据"
        >
          <el-table-column type="index" label="序号" width="60" align="center">
            <template slot-scope="scope">
              {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          
          <el-table-column label="课题名称" min-width="200" align="center">
            <template slot-scope="scope">
              <span class="diagram-name" :class="{ current: currentTaskBookId === scope.row.id }">
                {{ scope.row.title || '-' }}
              </span>
            </template>
          </el-table-column>
          
          <el-table-column label="列数" width="80" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.columns ? scope.row.columns.length : 0 }}</span>
            </template>
          </el-table-column>
          
          <el-table-column label="课题描述" width="120" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.description"
                size="mini"
                type="text"
                @click="viewDescription(scope.row.description)"
              >查看</el-button>
              <span v-else style="color:#ccc;">-</span>
            </template>
          </el-table-column>
          
          <el-table-column label="保存时间" width="180" align="center">
            <template slot-scope="scope">
              <div class="absolute-time">{{ formatTime(scope.row.timestamp) }}</div>
            </template>
          </el-table-column>
          
          <el-table-column label="操作" width="180" align="center" fixed="right">
            <template slot-scope="scope">
              <div class="action-buttons">
                <el-button size="mini" type="primary" @click="loadTaskBook(scope.row)">加载</el-button>
                <el-button size="mini" type="danger" @click="deleteTaskBook(scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :total="savedTaskBooks.length"
            @current-change="handlePageChange"
            layout="prev, pager, next" />
        </div>
      </div>
    </el-dialog>

    <!-- 课题描述查看弹框 -->
    <el-dialog title="课题描述" :visible.sync="showDescDialog" width="500px">
      <div style="white-space: pre-wrap; line-height: 1.8; font-size: 14px; color: #333; height: 300px; overflow-y: auto; padding: 4px 8px;">{{ currentDesc }}</div>
      <span slot="footer">
        <el-button @click="showDescDialog = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { baseURL, getHeaders } from '@/utils/request'
import { encrypt } from '@/utils/crypto'

export default {
  name: 'TaskBook',
  data() {
    return {
      rules: {
        title: [{ required: true, message: '请输入论文标题', trigger: 'blur' }],
        description: [{ required: true, message: '请输入课题简要描述', trigger: 'blur' }]
      },
      regeneratingIndex: null, // 正在重新生成的段落索引
      
      // 历史记录相关
      savedTaskBooks: [],
      currentTaskBookId: null,
      showHistoryModal: false,
      showDescDialog: false,
      currentDesc: '',
      
      // 分页
      currentPage: 1,
      pageSize: 10,
      
      // 积分配置
      pointsConfig: {
        taskBook: 4
      }
    }
  },
  computed: {
    form: {
      get() {
        return this.$store.state.taskBook.form
      },
      set(value) {
        this.$store.commit('setTaskBookForm', value)
      }
    },
    loading() {
      return this.$store.state.taskBook.loading
    },
    generatedContent() {
      return this.$store.state.taskBook.result
    },
    progress() {
      return this.$store.state.taskBook.progress
    },
    sections: {
      get() {
        return this.$store.state.taskBook.sections
      },
      set(value) {
        this.$store.commit('setTaskBookSections', value)
      }
    },
    paginatedTaskBooks() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.savedTaskBooks.slice(start, end)
    }
  },
  watch: {
    generatedContent(newVal) {
      // 只有在 sections 为空时才解析内容
      // 避免加载历史记录时被覆盖
      if (newVal && this.sections.length === 0) {
        this.parseSections(newVal)
      }
    }
  },
  created() {
    this.increasePageView()
    this.loadHistoryFromLocal()
    this.loadPointsConfig()
  },
  mounted() {
    // 优先从 store 恢复数据
    if (this.generatedContent && this.sections.length === 0) {
      this.parseSections(this.generatedContent)
    } else if (!this.generatedContent) {
      // 如果 store 中没有数据，则加载最近一个历史记录
      this.loadLatestTaskBook()
    }
  },
  methods: {
    // 加载积分配置
    async loadPointsConfig() {
      try {
        const response = await this.request.get('/ai/points-config')
        if (response.code === '200' && response.data) {
          this.pointsConfig = response.data
        }
      } catch (error) {
        console.error('加载积分配置失败:', error)
      }
    },
    
    increasePageView() {
      this.request.get('/pageView/increase', {
        params: { pageName: 'taskBook' }
      }).catch(() => {})
    },
    // 解析内容为段落
    parseSections(content) {
      if (!content) return
      
      const lines = content.split('\n')
      const newSections = []
      let currentSection = { title: '', content: '', editContent: '', wordLimit: 500 }
      
      lines.forEach(line => {
        const trimmedLine = line.trim()
        
        // 判断是否是标题
        const isTitle = this.form.columns.some(col => 
          trimmedLine === col.title || trimmedLine.startsWith(col.title)
        ) || /^(第[一二三四五六七八九十百\d]+[章节]|摘\s*要|ABSTRACT|Abstract|参考文献|致\s*谢)/.test(trimmedLine)
        
        // 如果遇到新标题，保存当前章节并开始新章节
        if (isTitle) {
          if (currentSection.title || currentSection.content.trim()) {
            newSections.push({ ...currentSection })
          }
          currentSection = { 
            title: trimmedLine, 
            content: '', 
            editContent: '', 
            wordLimit: 500 
          }
        } else if (trimmedLine) {
          // 普通内容，累积到当前章节
          currentSection.content += (currentSection.content ? '\n' : '') + line
        }
      })
      
      // 保存最后一个章节
      if (currentSection.title || currentSection.content.trim()) {
        newSections.push(currentSection)
      }
      
      this.sections = newSections
    },
    
    // 格式化段落文本
    formatSectionText(section) {
      let html = ''
      
      // 先显示标题
      if (section.title) {
        const escapedTitle = section.title
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;')
        
        html += `<h3 style="font-size: 14pt; font-weight: bold; margin: 0 0 1em 0; text-indent: 0; color: #111827;">${escapedTitle}</h3>`
      }
      
      // 再显示内容
      if (section.content) {
        html += section.content
          .split('\n')
          .map(line => {
            const trimmedLine = line.trim()
            if (!trimmedLine) return '<p style="margin: 0.5em 0;">&nbsp;</p>'
            
            const escapedLine = line
              .replace(/&/g, '&amp;')
              .replace(/</g, '&lt;')
              .replace(/>/g, '&gt;')
              .replace(/"/g, '&quot;')
              .replace(/'/g, '&#039;')
              .trim()
            
            return `<p style="margin: 0.5em 0; text-indent: 2em; text-align: justify;">${escapedLine}</p>`
          })
          .join('')
      }
      
      return html
    },
    
    // 重新生成某一段
    regenerateSection(index) {
      const section = this.sections[index]
      if (!section) return
      
      // 构建重新生成的提示
      const prompt = section.editContent || `请重新生成这一段内容`
      
      this.regeneratingIndex = index
      
      // 使用 JSON 格式代替 FormData，以便加密
      const requestData = {
        title: this.form.title,
        description: this.form.description,
        sectionTitle: section.title || '',
        originalContent: section.content || '',
        prompt: prompt,
        wordLimit: section.wordLimit || 500
      }
      
      // 加密请求数据
      const jsonString = JSON.stringify(requestData)
      const encrypted = encrypt(jsonString)
      
      fetch(baseURL + '/ai/regenerateTaskBookSection', {
        method: 'POST',
        headers: {
          ...getHeaders(),
          'X-Encrypt': 'true'
        },
        body: encrypted
      }).then(response => {
        if (!response.ok) throw new Error('请求失败：' + response.status)
        
        const reader = response.body.getReader()
        const decoder = new TextDecoder('utf-8')
        let buffer = ''
        let newContent = ''
        
        const readStream = () => {
          reader.read().then(({ done, value }) => {
            if (done) {
              // 更新该段落内容
              if (newContent.trim()) {
                const updatedSections = [...this.sections]
                updatedSections[index].content = newContent
                updatedSections[index].editContent = ''
                this.sections = updatedSections
                this.$message.success('重新生成成功')
                // 更新历史记录
                this.updateCurrentHistory()
              }
              this.regeneratingIndex = null
              return
            }
            
            buffer += decoder.decode(value, { stream: true })
            const lines = buffer.split('\n')
            buffer = lines.pop()
            
            for (const line of lines) {
              if (!line.startsWith('data: ')) continue
              const data = line.slice(6)
              
              if (data.trim() === '[DONE]') {
                if (newContent.trim()) {
                  const updatedSections = [...this.sections]
                  updatedSections[index].content = newContent
                  updatedSections[index].editContent = ''
                  this.sections = updatedSections
                  this.$message.success('重新生成成功')
                  // 更新历史记录
                  this.updateCurrentHistory()
                }
                this.regeneratingIndex = null
                return
              }
              
              if (data.trim().startsWith('[ERROR]')) {
                this.$message.error(data.trim().replace('[ERROR] ', ''))
                this.regeneratingIndex = null
                return
              }
              
              if (data.trim().startsWith('[PROGRESS]')) {
                // 显示进度提示（可以在按钮上显示）
                continue
              }
              
              newContent += data.replace(/\\n/g, '\n')
              // 实时更新显示 - 使用 mutation 更新 store
              this.$store.commit('updateTaskBookSection', { index, content: newContent })
            }
            
            readStream()
          }).catch(e => {
            this.$message.error('生成失败：' + e.message)
            this.regeneratingIndex = null
          })
        }
        
        readStream()
      }).catch(e => {
        this.$message.error('请求失败：' + e.message)
        this.regeneratingIndex = null
      })
    },
    
    addColumn() {
      if (this.form.columns.length < 15) {
        const newColumns = [...this.form.columns, { title: '', wordLimit: 500 }]
        this.form = {
          ...this.form,
          columns: newColumns
        }
      }
    },
    removeColumn(index) {
      if (this.form.columns.length > 1) {
        const newColumns = this.form.columns.filter((_, i) => i !== index)
        this.form = {
          ...this.form,
          columns: newColumns
        }
      }
    },
    
    // 历史记录相关方法
    saveToHistory() {
      const taskBook = {
        id: Date.now(),
        timestamp: Date.now(),
        title: this.form.title,
        description: this.form.description,
        columns: this.form.columns,
        sections: this.sections,
        generatedContent: this.generatedContent
      }
      
      const history = JSON.parse(localStorage.getItem('taskBookHistory') || '[]')
      history.unshift(taskBook)
      
      // 只保留最近20条
      if (history.length > 20) {
        history.splice(20)
      }
      
      localStorage.setItem('taskBookHistory', JSON.stringify(history))
      this.savedTaskBooks = history
      this.currentTaskBookId = taskBook.id
    },
    
    updateCurrentHistory() {
      // 只更新现有的历史记录，不创建新记录
      if (!this.currentTaskBookId) {
        return
      }
      
      // 从 sections 重建完整的 generatedContent
      const fullContent = this.sections.map(s => {
        let text = ''
        if (s.title) text += s.title + '\n'
        if (s.content) text += s.content
        return text
      }).join('\n\n')
      
      // 更新 store 中的 generatedContent
      this.$store.commit('setTaskBookResult', fullContent)
      
      const history = JSON.parse(localStorage.getItem('taskBookHistory') || '[]')
      const index = history.findIndex(item => item.id === this.currentTaskBookId)
      
      if (index > -1) {
        // 更新现有记录（替换）
        history[index] = {
          id: this.currentTaskBookId, // 保持原有ID
          timestamp: Date.now(), // 更新时间戳
          title: this.form.title,
          description: this.form.description,
          columns: this.form.columns,
          sections: this.sections,
          generatedContent: fullContent // 使用重建的完整内容
        }
        
        localStorage.setItem('taskBookHistory', JSON.stringify(history))
        this.savedTaskBooks = history
      }
    },
    
    loadHistoryFromLocal() {
      const history = JSON.parse(localStorage.getItem('taskBookHistory') || '[]')
      this.savedTaskBooks = history
    },
    
    loadLatestTaskBook() {
      if (this.savedTaskBooks.length === 0) return
      
      const latest = this.savedTaskBooks[0]
      this.loadTaskBookData(latest)
    },
    
    loadTaskBook(taskBook) {
      this.$confirm('确定要加载这个任务书吗？当前内容将被替换。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loadTaskBookData(taskBook)
        this.showHistoryModal = false
        this.$message.success('任务书加载成功')
      }).catch(() => {})
    },
    
    loadTaskBookData(taskBook) {
      // 加载表单数据
      this.form = {
        title: taskBook.title,
        description: taskBook.description,
        columns: taskBook.columns
      }
      
      // 加载生成的内容
      if (taskBook.sections) {
        this.sections = taskBook.sections
      }
      if (taskBook.generatedContent) {
        this.$store.commit('setTaskBookResult', taskBook.generatedContent)
      }
      
      this.currentTaskBookId = taskBook.id
    },
    
    deleteTaskBook(taskBook) {
      this.$confirm('确定要删除这个任务书吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const history = JSON.parse(localStorage.getItem('taskBookHistory') || '[]')
        const index = history.findIndex(item => item.id === taskBook.id)
        if (index > -1) {
          history.splice(index, 1)
          localStorage.setItem('taskBookHistory', JSON.stringify(history))
          this.savedTaskBooks = history
          this.$message.success('删除成功')
        }
      }).catch(() => {})
    },
    
    showHistoryDialog() {
      this.showHistoryModal = true
      this.currentPage = 1
    },
    
    closeHistoryDialog() {
      this.showHistoryModal = false
    },
    
    handlePageChange(page) {
      this.currentPage = page
    },
    
    viewDescription(desc) {
      this.currentDesc = desc
      this.showDescDialog = true
    },
    
    formatTime(timestamp) {
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    
    generate() {
      this.$refs.taskForm.validate(valid => {
        if (!valid) {
          this.$message.warning('请填写完整信息')
          return
        }

        // 检查列标题是否为空
        if (this.form.columns.length === 0) {
          this.$message.warning('请至少添加一个章节标题')
          return
        }

        // 检查是否有空的列标题
        const emptyColumn = this.form.columns.find(col => !col.title || col.title.trim() === '')
        if (emptyColumn) {
          this.$message.warning('请填写所有章节标题，不能为空')
          return
        }

        // 检查字数限制是否有效
        const invalidLimit = this.form.columns.find(col => !col.wordLimit || col.wordLimit < 100 || col.wordLimit > 3000)
        if (invalidLimit) {
          this.$message.warning('字数限制必须在100-3000之间')
          return
        }

        // 添加积分确认提示
        this.$confirm(`此操作将消耗${this.pointsConfig.taskBook}积分，是否继续？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.executeGenerate()
        }).catch(() => {
          this.$message.info('已取消操作')
        })
      })
    },
    
    executeGenerate() {
        this.$store.commit('setTaskBookLoading', true)
        this.$store.commit('clearTaskBook')

        // 使用 JSON 格式代替 FormData，以便加密
        const requestData = {
          title: this.form.title,
          description: this.form.description,
          columns: this.form.columns
        }
        
        // 加密请求数据
        const jsonString = JSON.stringify(requestData)
        const encrypted = encrypt(jsonString)

        fetch(baseURL + '/ai/generateTaskBookStream', {
          method: 'POST',
          headers: {
            ...getHeaders(),
            'X-Encrypt': 'true'
          },
          body: encrypted
        }).then(response => {
          if (!response.ok) throw new Error('请求失败：' + response.status)

          const reader = response.body.getReader()
          const decoder = new TextDecoder('utf-8')
          let buffer = ''

          const readStream = () => {
            reader.read().then(({ done, value }) => {
              if (done) {
                this.$store.commit('setTaskBookLoading', false)
                return
              }

              buffer += decoder.decode(value, { stream: true })
              const lines = buffer.split('\n')
              buffer = lines.pop()

              for (const line of lines) {
                if (!line.startsWith('data: ')) continue
                const data = line.slice(6)

                if (data.trim() === '[DONE]') {
                  this.$store.commit('setTaskBookLoading', false)
                  // 生成成功后保存到历史记录
                  this.saveToHistory()
                  this.$message.success('任务书生成成功')
                  // 刷新积分
                  this.refreshPoints()
                  return
                }

                if (data.trim().startsWith('[ERROR]')) {
                  this.$message.error(data.trim().replace('[ERROR] ', ''))
                  this.$store.commit('setTaskBookLoading', false)
                  return
                }

                if (data.trim().startsWith('[PROGRESS]')) {
                  // 显示进度提示
                  const progressMsg = data.trim().replace('[PROGRESS] ', '').replace(/\\n/g, '')
                  this.$store.commit('setTaskBookProgress', progressMsg)
                  continue
                }

                this.$store.commit('appendTaskBookResult', data.replace(/\\n/g, '\n'))
                
                // 实时更新段落显示
                this.parseSections(this.$store.state.taskBook.result)
                
                // 自动滚动到底部
                this.$nextTick(() => {
                  const contentArea = this.$el.querySelector('.preview-content')
                  if (contentArea) {
                    contentArea.scrollTop = contentArea.scrollHeight
                  }
                })
              }

              readStream()
            }).catch(e => {
              this.$message.error('生成失败：' + e.message)
              this.$store.commit('setTaskBookLoading', false)
            })
          }

          readStream()
        }).catch(e => {
          this.$message.error('请求失败：' + e.message)
          this.$store.commit('setTaskBookLoading', false)
        })
    },
    
    // 刷新积分
    refreshPoints() {
      // 使用全局方法刷新积分
      this.$refreshPoints()
    },
    exportWord() {
      if (this.sections.length === 0) return
      
      // 合并所有章节内容（标题 + 内容）
      const fullContent = this.sections.map(s => {
        let text = ''
        if (s.title) text += s.title + '\n'
        if (s.content) text += s.content
        return text
      }).join('\n\n')

      fetch(baseURL + '/ai/exportTaskBookWord', {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({
          title: this.form.title || '任务书',
          content: fullContent,
          columns: JSON.stringify(this.form.columns)
        })
      }).then(response => {
        if (!response.ok) throw new Error('导出失败')
        return response.blob()
      }).then(blob => {
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = (this.form.title || '任务书') + '.docx'
        a.click()
        URL.revokeObjectURL(url)
      }).catch(e => {
        this.$message.error('导出失败：' + e.message)
      })
    },
    formatPlainText(text) {
      if (!text) return ''
      
      return text
        .split('\n')
        .map(line => {
          const trimmedLine = line.trim()
          if (!trimmedLine) return '<p style="margin: 0.5em 0;">&nbsp;</p>'
          
          const escapedLine = line
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;')
            .trim()
          
          // 检查是否是章节标题（与配置的章节标题匹配）
          const isChapterTitle = this.form.columns.some(col => 
            escapedLine === col.title || escapedLine.startsWith(col.title)
          )
          
          if (isChapterTitle) {
            return `<h3 style="font-size: 14pt; font-weight: bold; margin: 1.5em 0 0.8em 0; text-indent: 0; color: #111827;">${escapedLine}</h3>`
          }
          
          // Markdown 标题（兼容 AI 偶尔输出 # 的情况）
          const mdMatch = escapedLine.match(/^(#{1,4})\s+(.+)/)
          if (mdMatch) {
            return `<h2 style="font-size: 16pt; font-weight: bold; margin: 1em 0 0.5em 0; text-indent: 0;">${mdMatch[2]}</h2>`
          }
          
          // 一级：第X章 / 摘要 / Abstract / 参考文献 / 致谢
          if (/^(第[一二三四五六七八九十百\d]+[章节]\s*[\u4e00-\u9fa5a-zA-Z（(【\[「『《](?!为|主要|介绍|阐述|将|是|从|对|通过|分析|讨论|研究|详细|包含|包括)|摘\s*要|ABSTRACT|Abstract|参考文献|致\s*谢)/.test(escapedLine)) {
            return `<h2 style="font-size: 16pt; font-weight: bold; margin: 1em 0 0.5em 0; text-indent: 0;">${escapedLine}</h2>`
          }
          
          // 四级：1.1.1.1 或 1.1.1.1 标题
          if (/^\d+\.\d+\.\d+\.\d+[\s\S]/.test(escapedLine)) {
            return `<h4 style="font-size: 12pt; font-weight: bold; margin: 0.6em 0 0.3em 0; text-indent: 0;">${escapedLine}</h4>`
          }
          
          // 三级：1.1.1 标题
          if (/^\d+\.\d+\.\d+[\s\S]/.test(escapedLine)) {
            return `<h3 style="font-size: 13pt; font-weight: bold; margin: 0.7em 0 0.4em 0; text-indent: 0;">${escapedLine}</h3>`
          }
          
          // 二级：1.1 标题
          if (/^\d+\.\d+[\s\S]/.test(escapedLine)) {
            return `<h3 style="font-size: 14pt; font-weight: bold; margin: 0.8em 0 0.4em 0; text-indent: 0;">${escapedLine}</h3>`
          }
          
          // 参考文献条目
          if (/^\[\d+\].+/.test(escapedLine)) {
            return `<p style="margin: 0.3em 0; text-indent: 0;">${escapedLine}</p>`
          }
          
          // 普通段落
          return `<p style="margin: 0.5em 0; text-indent: 2em; text-align: justify;">${escapedLine}</p>`
        })
        .join('')
    }
  }
}
</script>

<style scoped>
.taskbook-page {
  height: calc(100vh - 118px);
  display: flex;
  overflow: hidden;
}

.editor-panel {
  width: 380px;
  background: #fff;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  overflow: hidden;
  border-right: 1px solid #d1d5db;
}

.panel-header {
  padding: 16px 24px;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.panel-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}

.panel-icon {
  width: 22px;
  height: 22px;
  color: #4f46e5;
}

.btn-history {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-size: 13px;
  color: #4f46e5;
  background: #fff;
  border: 1px solid #4f46e5;
  border-radius: 0;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-history:hover {
  background: #4f46e5;
  color: #fff;
}

.btn-history svg {
  width: 16px;
  height: 16px;
}

.ai-form-panel {
  padding: 16px;
  flex: 1;
  overflow-y: auto;
}

.ai-form-panel .el-form-item {
  margin-bottom: 16px;
}

.func-editor {
  width: 100%;
  height: 200px;
  background: #ffffff;
  color: #333;
  font-family: inherit;
  font-size: 13px;
  padding: 8px 12px;
  resize: none;
  border: 1px solid #dcdfe6;
  outline: none;
  line-height: 1.6;
  box-sizing: border-box;
}

.func-editor:focus {
  border-color: #4f46e5;
}

.panel-footer {
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
}

.btn-ai {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  border: none;
  background: #10b981;
  color: #fff;
  transition: background 0.2s;
}

.btn-ai:hover:not(:disabled) {
  background: #059669;
}

.btn-ai:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-points {
  font-size: 16px;
  font-weight: 600;
  opacity: 0.9;
  white-space: nowrap;
}

.ai-icon {
  width: 26px;
  height: 26px;
  object-fit: contain;
}

.preview-panel {
  flex: 1;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-left: 10px;
  border-left: 1px solid #d1d5db;
}

.preview-header {
  padding: 12px 24px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.preview-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}

.btn-export {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  font-size: 13px;
  color: #fff;
  background: #4f46e5;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-export:hover:not(:disabled) {
  background: #4338ca;
}

.btn-export:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.preview-content {
  flex: 1;
  overflow-y: auto;
}

.empty-state, .loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 12px;
  padding: 60px 20px;
  background: #fafafa;
}

.empty-state svg {
  color: #d1d5db;
}

.empty-state p {
  font-size: 14px;
  font-weight: normal;
  margin: 0;
  text-align: center;
  line-height: 1.6;
}

.loading-state {
  color: #6b7280;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #e5e7eb;
  border-top-color: #4f46e5;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.loading-sub {
  font-size: 12px;
  color: #9ca3af;
  margin-top: -4px;
}

.empty-icon {
  width: 48px;
  height: 48px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-text {
  font-size: 15px;
  font-weight: 500;
  color: #6b7280;
}

.document-body {
  width: 100%;
  max-width: 1400px;
  padding: 24px;
  margin: 0 auto;
}

.global-progress-bar {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
}

.section-progress {
  background: #fef3c7;
  border: 1px solid #fcd34d;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.progress-text {
  font-size: 13px;
  color: #1d4ed8;
  font-weight: 500;
}

.section-progress .progress-text {
  color: #92400e;
}

.progress-dots {
  display: inline-flex;
  gap: 2px;
}

.progress-dots span {
  display: inline-block;
  font-size: 13px;
  color: #1d4ed8;
  animation: dotBounce 1.2s infinite;
}

.section-progress .progress-dots span {
  color: #92400e;
}

.progress-dots span:nth-child(2) {
  animation-delay: 0.2s;
}

.progress-dots span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes dotBounce {
  0%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-4px);
  }
}

.section-row {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
  align-items: flex-start;
  padding: 20px;
  border: 1px solid #d1d5db;
  background: #f9fafb;
}

.section-content {
  flex: 1;
  background: #fff;
  padding: 20px;
  border: 1px solid #d1d5db;
  min-height: 100px;
  font-family: 'Times New Roman', '宋体', serif;
  font-size: 12pt;
  line-height: 1.8;
  color: #000;
}

.section-control {
  width: 320px;
  flex-shrink: 0;
}

.control-box {
  background: #fff;
  border: 2px solid #2563eb;
  padding: 16px;
}

.control-title {
  font-size: 14px;
  font-weight: 600;
  color: #2563eb;
  margin-bottom: 12px;
}

.control-textarea {
  width: 100%;
  min-height: 100px;
  padding: 10px;
  border: 1px solid #d1d5db;
  font-size: 13px;
  line-height: 1.6;
  resize: vertical;
  font-family: inherit;
  margin-bottom: 12px;
}

.control-textarea:focus {
  outline: none;
  border-color: #2563eb;
}

.control-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.word-limit-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.word-limit-label {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}

.word-limit-input {
  flex: 1;
}

.btn-regenerate {
  width: 100%;
  padding: 10px;
  background: #2563eb;
  color: #fff;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-regenerate:hover:not(:disabled) {
  background: #1d4ed8;
}

.btn-regenerate:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.document-text {
  background: #fff;
  padding: 40px;
  font-family: 'Times New Roman', '宋体', serif;
  font-size: 12pt;
  line-height: 1.8;
  color: #000;
}

.progress-bar-wrap {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #eff6ff;
  border-bottom: 1px solid #bfdbfe;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: -40px -40px 20px -40px;
}

.progress-bar-text {
  font-size: 13px;
  color: #1d4ed8;
}

.progress-dots {
  display: inline-flex;
  gap: 2px;
}

.progress-dots span {
  display: inline-block;
  font-size: 13px;
  color: #1d4ed8;
  animation: dotBounce 1.2s infinite;
}

.progress-dots span:nth-child(2) {
  animation-delay: 0.2s;
}

.progress-dots span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes dotBounce {
  0%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-4px);
  }
}

.typing-cursor {
  display: inline-block;
  width: 2px;
  height: 1em;
  background: #4f46e5;
  margin-left: 2px;
  vertical-align: text-bottom;
  animation: blink 0.8s step-end infinite;
}

@keyframes blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

.column-config {
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

.column-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.column-icon {
  width: 18px;
  height: 18px;
  color: #6b7280;
}

.btn-add-column {
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  background: #4f46e5;
  color: #fff;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-add-column:hover:not(:disabled) {
  background: #4338ca;
}

.btn-add-column:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.column-list {
  padding: 12px;
}

.column-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
  padding: 12px;
  background: #f9fafb;
}

.column-item:last-child {
  margin-bottom: 0;
}

.column-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.column-title-input {
  flex: 1;
}

.column-limit-input {
  width: 140px;
}

.word-limit-label {
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
  flex-shrink: 0;
}

.word-limit-unit {
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
  flex-shrink: 0;
}

.column-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: #e5e7eb;
  color: #6b7280;
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
}

.btn-remove-column {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  background: #ef4444;
  color: #fff;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
  flex-shrink: 0;
}

.btn-remove-column:hover {
  background: #dc2626;
}

/* 历史记录对话框样式 */
.history-content {
  padding: 0;
}

.history-description {
  background: #f9fafb;
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 16px;
}

.history-description ul {
  margin: 0;
  padding-left: 20px;
  list-style: none;
}

.history-description li {
  color: #6b7280;
  font-size: 14px;
  line-height: 1.8;
}

.diagram-name {
  font-weight: 500;
  color: #111827;
}

.diagram-name.current {
  color: #2563eb;
  font-weight: 600;
}

.absolute-time {
  font-size: 13px;
  color: #6b7280;
}

.action-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  padding: 16px 0;
}
</style>
